import { simpleApi } from "~/common/API/simpleApi";
import { ElNotification } from "element-plus";
import type { IShowCaseUpdateData, IUpdateShowCaseData, IShowcaseContact, ShowcaseContactType } from "~/interfaces/publisher/showcase";

export default class ShowcaseService {
    static getShowCaseData = async () => {
        const endpoint = "/user/showcase/my";

        const response: any = await simpleApi(endpoint, {});
        if (response?.error && response?.error === 404) {
            return null;
        }
        return response;

    }

    static getShowCaseDataPublic = async (url: string) => {
        const endpoint = "/user/showcase/";
        const response: any = await simpleApi(endpoint, {
            params: { slug: url }
        });
        return response;
    }

    static saveShowCase = async (data: IShowCaseUpdateData) => {
        const endpoint = "/user/showcase";
        try {
            const response: any = await simpleApi(endpoint, {
                method: "POST",
                body: { ...data }
            });
            return response;
        } catch (error: any) {
            ElNotification({
                title: "Ошибка сохранения данных",
                message: "попробуйте чуть позже или свяжитесь с администратором...",
                type: "error",
            });
            console.error(error);
            return null;
        }
    }

    static saveShowcasePlace = async (id: number, places: { social: string; id: number }[]) => {
        const endpoint = "/user/showcase-place";
        try {
            const response: any = await simpleApi(endpoint, {
                method: "POST",
                body: { id, places }
            });
            ElNotification({
                title: "Успешно",
                message: "Канал успешно добавлен в витрину",
                type: "success",
            });
            return response;
        } catch (error: any) {
            ElNotification({
                title: "Ошибка сохранения данных",
                message: "попробуйте чуть позже или свяжитесь с администратором...",
                type: "error",
            });
            console.error(error);
            return null;
        }
    }

    static deleteShowcasePlace = async (id: number) => {
        const endpoint = "/user/showcase-place";
        try {
            const response: any = await simpleApi(endpoint, {
                method: "DELETE",
                body: { id }
            });
            return response;
        } catch (error: any) {
            ElNotification({
                title: "Ошибка удаления данных",
                message: "попробуйте чуть позже или свяжитесь с администратором...",
                type: "error",
            });
            console.error(error);
            return null;
        }
    }

    static deleteShowcasePlaces = async (places: { social: string; id: number }[]) => {
        const endpoint = "/user/showcase-place";
        try {
            const response: any = await simpleApi(endpoint, {
                method: "DELETE",
                body: { places }
            });
            return response;
        } catch (error: any) {
            ElNotification({
                title: "Ошибка удаления данных",
                message: "попробуйте чуть позже или свяжитесь с администратором...",
                type: "error",
            });
            console.error(error);
            return null;
        }
    }

    static createShowcaseContacts = async (contacts: IShowcaseContact[]) => {
        const endpoint = "/user/showcase-contact";
        try {
            const response: any = await simpleApi(endpoint, {
                method: "POST",
                body: { contacts }
            });
            return response;
        } catch (error: any) {
            ElNotification({
                title: "Ошибка сохранения контакта",
                message: "проверьте формат или попробуйте чуть позже...",
                type: "error",
            });
            console.error(error);
            return null;
        }
    }

    static updateShowcaseContact = async (contact: IShowcaseContact) => {
        const endpoint = "/user/showcase-contact";
        try {
            const response: any = await simpleApi(endpoint, {
                method: "PUT",
                body: { ...contact }
            });
            return response;
        } catch (error: any) {
            ElNotification({
                title: "Ошибка сохранения контакта",
                message: "проверьте формат или попробуйте чуть позже...",
                type: "error",
            });
            console.error(error);
            return null;
        }
    }

    static deleteShowcaseContacts = async (types: ShowcaseContactType[]) => {
        const endpoint = "/user/showcase-contact";
        try {
            const response: any = await simpleApi(endpoint, {
                method: "DELETE",
                params: { "types[]": types }
            });
            return response;
        } catch (error: any) {
            ElNotification({
                title: "Ошибка удаления контакта",
                message: "попробуйте чуть позже или свяжитесь с администратором...",
                type: "error",
            });
            console.error(error);
            return null;
        }
    }

    static updateShowCase = async (data: IUpdateShowCaseData) => {
        const endpoint = "/user/showcase";
        const { id, ...rest } = data;
        try {
            const response: any = await simpleApi(endpoint, {
                method: "PUT",
                body: { ...rest },
                params: { id }
            });
            return response;
        } catch (error: any) {
            ElNotification({
                title: "Ошибка активации!",
                message: "Чтобы активировать витрину, создайте реквизиты",
                type: "error",
            });
            console.error(error);
            return null;
        }
    }
}